import { tourText, type TourStep, type TourStepContext } from './tours';

export interface ResolvedStep extends TourStep {
  spot: boolean;
}

export function resolveSteps(
  steps: TourStep[],
  ctx: TourStepContext,
  isVisible: (anchor: string) => boolean,
): ResolvedStep[] {
  const out: ResolvedStep[] = [];
  for (const step of steps) {
    if (step.when && !step.when(ctx)) continue;
    if (step.anchor == null) out.push({ ...step, spot: false });
    else if (isVisible(step.anchor)) out.push({ ...step, spot: true });
    else if (step.inMenu) out.push({ ...step, spot: false });
  }
  return out;
}

export function resolveOnPage(
  step: TourStep,
  ctx: TourStepContext,
  isVisible: (anchor: string) => boolean,
): ResolvedStep | null | 'wait' {
  if (step.when && !step.when(ctx)) return null;
  if (step.anchor == null || isVisible(step.anchor)) return { ...step, spot: step.anchor != null };
  if (step.empty && isVisible(step.empty.anchor)) {
    return { ...step, anchor: step.empty.anchor, body: tourText(step.empty.body, ctx), spot: true };
  }
  return 'wait';
}

export function findAnchor(anchor: string): HTMLElement | null {
  const nodes = document.querySelectorAll<HTMLElement>(`[data-tour="${CSS.escape(anchor)}"]`);
  for (const node of nodes) {
    if (node.getClientRects().length > 0) return node;
  }
  return null;
}
